import { render, staticRenderFns } from "./channel_config.vue?vue&type=template&id=91bf87e6&scoped=true"
import script from "./channel_config.vue?vue&type=script&lang=js"
export * from "./channel_config.vue?vue&type=script&lang=js"
import style0 from "./channel_config.vue?vue&type=style&index=0&id=91bf87e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bf87e6",
  null
  
)

export default component.exports